import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import delayed from 'utils/delayed';

import LoadStatus from 'config/load_status';

import reauthenticate from './usecases/reauthenticate';

const useReauthenticate = ({ email, password, onVerified }) => {
  const [reauthenticateStatus, setReauthenticateStatus] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (reauthenticateStatus !== LoadStatus.LOADING) return;

    const request = async () => {
      try {
        const emailVerified = await delayed(reauthenticate(email, password));

        if (!emailVerified) {
          setReauthenticateStatus(null);
          enqueueSnackbar('Email was not verified', { variant: 'error' });
        } else {
          setReauthenticateStatus(LoadStatus.DONE);
          onVerified();
        }
      } catch (error) {
        setReauthenticateStatus(LoadStatus.ERROR);
        enqueueSnackbar('It was not possible to check if email was verified', {
          variant: 'error',
        });
        throw error;
      }
    };
    request();
  }, [reauthenticateStatus, email, password, enqueueSnackbar, onVerified]);

  const checkVerification = () => {
    if (reauthenticateStatus === LoadStatus.LOADING) return;
    if (reauthenticateStatus === LoadStatus.DONE) return;

    setReauthenticateStatus(LoadStatus.LOADING);
  };

  return {
    isLoading: reauthenticateStatus === LoadStatus.LOADING,
    checkVerification,
  };
};

export default useReauthenticate;
